export default {
  baseUrl: {
    // dev: "http://localhost:8881", // 开发环境
    // dev: "http://120.27.137.50:81/api", // 测试环境
    dev: 'https://www.fangxiaolaw.cn/api',
    // prod: 'http://production.com',
  },
};